import React, { useEffect, useState } from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import { useTranslation } from "react-i18next";
import { getActiveCustomerPing } from "../../features/apiCalls";
import { useDispatch, useSelector } from "react-redux";

const PingDetails = ({ show, setShow, customer }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const ping = useSelector((state) => state.mikrotik?.ping);

  const [isLoading, setIsLoading] = useState(false);

  const pingFields = [
    { label: t("mikrotik"), key: "mikrotik" },
    { label: t("host"), key: "host" },
    { label: t("packetLoss"), key: "packet-loss" },
    { label: t("averageTime"), key: "avg-rtt" },
  ];

  useEffect(() => {
    if (customer?.id) {
      getActiveCustomerPing(dispatch, customer?.id, setIsLoading);
    }
  }, [show, customer]);

  return (
    <ComponentCustomModal
      {...{
        show,
        setShow,
        centered: true,
        size: "md",
        header: customer?.pppoe?.name
          ? customer?.pppoe?.name + " " + t("ping")
          : customer?.name + " " + t("ping"),
      }}
    >
      <div>
        {isLoading
          ? pingFields.map((field, index) => (
              <div
                className="displayGridManual3_7 placeholder-glow"
                key={index}
              >
                <p>{field.label}</p>
                <p className="placeholder rounded-pill"></p>
              </div>
            ))
          : pingFields.map(
              (field, index) =>
                ping?.[field.key] && (
                  <div className="displayGridManual3_7" key={index}>
                    <p>{field.label}</p>
                    <p>{ping?.[field.key]}</p>
                  </div>
                )
            )}
      </div>
    </ComponentCustomModal>
  );
};

export default PingDetails;
